module.exports = new __parcel__URL__("witch-hut.83d807f8.webp").toString();